<div class="header">
  <h2><i class="fas fa-atlas"></i><span class="label">Custom Domain</span></h2>
</div>

<div class="accounts">
  <span class="title">Account level domain name</span>
  <apsis-back-office-account-domain-add
    [accounts]="accounts$ | async"
    [selectedAccount]="selectedAccount$ | async"
    [selectedAccountDomainName]="selectedAccountDomainName$ | async"
    (selectAccount)="selectAccount($event)"
    (selectAccountDomainName)="selectAccountDomainName($event)"
  ></apsis-back-office-account-domain-add>
</div>
<app-switch-checkbox
  bsSize="sm"
  [checked]="selectedAccountToggle$ | async"
  [disabled]="!(selectedAccount$ | async)"
  (change)="toggleDomain($event)"
>
  <span>Custom domain settings enabled for this account</span>
</app-switch-checkbox>
<div class="sections" *ngIf="selectedAccount$ | async">
  <span class="title">Section level domain names</span>
  <apsis-back-office-sections-domain-add
    [sections]="sections$ | async"
    [selectedSectionsDomains]="selectedSectionsDomains$ | async"
    (addSectionDomain)="addSectionDomain($event)"
    (removeSectionDomain)="removeSectionDomain($event)"
    (selectSectionDomain)="selectSectionDomain($event)"
  ></apsis-back-office-sections-domain-add>
</div>
<div class="actions">
  <button (click)="cancel()">Cancel</button>
  <button
    class="save"
    [ngClass]="{ disabled: !(enableSave$ | async) }"
    (click)="save()"
  >
    Save
  </button>
</div>
